

export class RMInvoicePrintReq {
    grnId?: number;


    constructor(

        grnId?:number,
        ){
      this.grnId = grnId;

    }
  }